import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { BiomeNavIcon, NavIconName } from '@codametrix/verdigris';
export const navComponents = {
    Admin: /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.Admin,
        titleText: "Admin"
    }),
    Cases: /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.CaseList,
        titleText: "Cases"
    }),
    'Cases (Classic)': /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.CaseList,
        titleText: "Cases (Classic)"
    }),
    Analytics: /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.Insights,
        titleText: "Analytics"
    }),
    Insights: /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.Insights,
        titleText: "Analytics"
    }),
    'Provider Directory': /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.Providers,
        titleText: "Provider Directory"
    }),
    'Queue Settings': /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.WorklistConfig,
        titleText: "Queue Settings"
    }),
    'Coding Quality': /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.CodingQuality,
        titleText: "Coding Quality"
    }),
    'Quality Assessment': /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.Classfication,
        titleText: "Quality Assessment"
    }),
    Worklist: /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.Worklist,
        titleText: "Worklist"
    }),
    Search: /*#__PURE__*/ _jsx(BiomeNavIcon, {
        iconName: NavIconName.Search,
        titleText: "Search"
    })
};
